module.exports = __webpack_public_path__ + "static/media/landing-image.08bf3255.jpg";